import moment from "moment";

export const isDateOverForSecondModule = (startDate, endDate) => {
  if (!startDate || !endDate) return false;

  const start = moment(startDate);
  const end = moment(endDate);
  const duration = moment.duration(end.diff(start));
  const midpoint = start.clone().add(duration.asMilliseconds() / 2, 'milliseconds');
  return new Date() > moment(midpoint.toDate()).subtract(10, "days");
};

export const numberToOrdinalText = (num) => {
  if (num === 0) return "Zero";

  const ordinalWords = [
    "Zeroth", "First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth",
    "Tenth", "Eleventh", "Twelfth", "Thirteenth", "Fourteenth", "Fifteenth", "Sixteenth",
    "Seventeenth", "Eighteenth", "Nineteenth"
  ];

  const tensWords = ["", "", "Twentieth", "Thirtieth", "Fortieth", "Fiftieth", "Sixtieth",
    "Seventieth", "Eightieth", "Ninetieth"];

  if (num < 20) return ordinalWords[num];

  const tens = Math.floor(num / 10);
  const ones = num % 10;

  if (ones === 0) return tensWords[tens];

  return (tensWords[tens] ? tensWords[tens].slice(0, -2) : ordinalWords[tens]) + "-" + ordinalWords[ones];
}

export const addSearchParams = (location, bug) => {
  const newSearchParams = new URLSearchParams(location.search);
  newSearchParams.set("isOpenDetails", "true");
  newSearchParams.set("id", bug.id);
  window.history.pushState({}, "", `${location.pathname}?${newSearchParams.toString()}`)
};

export const getSearchParams = (location) => {
  const searchParams = new URLSearchParams(location.search);
  const isOpenDetails = searchParams.get("isOpenDetails") === "true";
  const itemId = searchParams.get("id");
  return { isOpenDetails, itemId };
};

export const removeSearchParams = (location) => {
  const newSearchParams = new URLSearchParams(location.search);
  newSearchParams.delete("isOpenDetails");
  newSearchParams.delete("id");
  window.history.pushState({}, "", `${location.pathname}?${newSearchParams.toString()}`);
};